import React from 'react'
import { Box, Typography } from '@material-ui/core'

export const InfoWithDescription = ({ title, duration }) => {
    return (
        <Box pt={2}>
            <Typography
                style={{
                    marginBottom: '0.4rem',
                    fontWeight: '600',
                }}
            >
                {title}
            </Typography>
            <Typography color="textSecondary" style={{ fontSize: '0.9rem' }}>
                {duration}
            </Typography>
        </Box>
    )
}
